module.exports = __webpack_public_path__ + "img/1.2d56e7b5.png";